<ng-container *transloco="let t">
  <!-- Checkbox -->
  <div class="form-group">
    <mat-checkbox
      class="__multiline"
      [ngClass]="{ __error: field.invalid && field.dirty }"
      [formControl]="field">
      <span [innerHTML]="label"></span>
    </mat-checkbox>

    <div
      class="message __error"
      role="alert"
      *ngIf="field.invalid && field.dirty">
      <ng-container *ngIf="field.errors.required">{{ t('common.required') }}</ng-container>
    </div>
  </div>
</ng-container>
